/**
 * *****************************************************************************************************
 * Responsibility - provides the necessary functionality to pay for single or multiple invoices/ charges.
 * Takes the endpoint as an argument to decide what to pay for.
 * *************************************************************
 *
 * @format
 */

/** @format */
import {parseEntityError} from 'frontier-form';
import update from 'immutability-helper';
import React, {useState} from 'react';
import SuperAgent from 'superagent';
import dot from 'dot-object';

export const usePayBalance = props => {
    const {isPayingSingle, payMultipleList, isChargeBatch, singleCharge} = props;

    const [state, setState] = useState({
        editing_payment_method: true,
        payment_profile_id: false,
        payment_profile_label: '',
        isProcessing: false,
        paymentError: false,
        paid: false
    });

    const endPoint = isChargeBatch ? '/account/charge-batches/pay' : '/account/carts/pay';
    const reqBody = isChargeBatch ? 'charge_batch_id' : 'cart_id';

    const handleChange = updateTarget => {
        setState(currentState => update(currentState, updateTarget));
    };

    const handleChooseProfile = paymentProfile => {
        setState({
            payment_profile_label: paymentProfile.label,
            payment_profile_id: paymentProfile.id
        });
    };

    const handleClearPaymentMethod = () => {
        setState({
            payment_profile_id: false,
            payment_profile_label: ''
        });
    };

    const pay = async id => {
        try {
            const request = await SuperAgent.post(endPoint)
                .set('Accept', 'application/json')
                .send({
                    payment_profile_id: state.payment_profile_id,
                    [reqBody]: id
                });

            if (request.status === 200) return 'success';
        } catch (e) {
            const error = parseEntityError(dot.pick('response.body', e));
            return error;
        }
    };

    const handleSubmitPayment = async () => {
        setState({...state, isProcessing: true});

        // if the charge is provided use that one.
        const chargeToPayFor = singleCharge ? singleCharge.id : payMultipleList[0];
        const results = await pay(chargeToPayFor);

        if (results === 'success') {
            setState({isProcessing: false, is_complete: true});
            window.location.reload();
        } else {
            setState({
                isProcessing: false,
                paymentError: results
            });
        }
    };

    const handleSubmitPaymentMultiple = async () => {
        setState({...state, isProcessing: true});
        const requests = payMultipleList.map(item => pay(item));
        const results = await Promise.all(requests);
        if (results.filter(r => r !== 'success').length > 0) {
            setState({
                isProcessing: false,
                paymentError: results.map(msg => msg.message + '. ')
            });
        } else {
            setState({isProcessing: false, is_complete: true});
            window.location.reload();
        }
    };

    const handlePayment = () => {
        if (!state.payment_profile_id) {
            alert('Please select a payment method');
            return;
        }

        if (isPayingSingle) {
            handleSubmitPayment();
        } else {
            handleSubmitPaymentMultiple();
        }
    };

    // Return the state and functions that the component using this hook will need
    return {
        ...state,
        onChange: handleChange,
        onChooseProfile: handleChooseProfile,
        onClearPaymentMethod: handleClearPaymentMethod,
        handlePayment: handlePayment
    };
};
